import {useState} from 'react'
import {useRails} from '~/react/contexts/rails'

import {updatePayee as updatePayeeApi} from '../../api'

const useUpdatePayee = (supplierId, payeeId) => {
  const [isUpdating, setIsUpdating] = useState(false)
  const {authenticityToken} = useRails()

  const updatePayee = async (values) => {
    setIsUpdating(true)

    try {
      return await updatePayeeApi({
        supplierId,
        payeeId,
        authenticityToken,
        values,
      })
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    updatePayee,
    isUpdating,
  }
}

export default useUpdatePayee
